<template>
    <AdminLayout>
        <section class="grid grid-cols-7">
            <div class="col-span-5 py-2 px-10">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-5">
                            <p class="font-semibold text-xl text-neutral-800">Attendance Report</p>
                        </div>

                        <div class="flex mb-8 items-center bg-neutral-300/50 rounded-md p-1">
                            <p class="font-medium text-sm text-neutral-950">Attendance Record for {{monthName}}</p>
                            <div class="w-fit mx-3 ml-auto flex items-center bg-white pl-2 monthPickerCst rounded-md">
                                <p class="text-sm leading-none font-medium text-black">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 48 48">
                                        <path fill="#cfd8dc" d="M5 38V14h38v24c0 2.2-1.8 4-4 4H9c-2.2 0-4-1.8-4-4"/>
                                        <path fill="#f44336" d="M43 10v6H5v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4"/>
                                        <g fill="#b71c1c"><circle cx="33" cy="10" r="3"/><circle cx="15" cy="10" r="3"/></g>
                                        <path fill="#b0bec5" d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2M15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"/>
                                        <path fill="#90a4ae" d="M13 20h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4z"/>
                                    </svg>
                                </p>
                                <month-picker-input v-model="filterMonth" :no-default="true" @change="logEffectiveTo" placeholder="Select Month"/>
                            </div>
                            <div>
                                <!-- <button class="btn-primary"> Download <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2">
                                    <path fill="currentColor" d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z"></path></svg>
                                </button> -->
                            </div>
                        </div>

                        <div class="grid grid-cols-4 gap-3 mb-3">
                            <div class="text-xs font-medium text-neutral-800 p-3 bg-neutral-100 rounded-md">Total Days Present - <span>{{totalPresent}}</span> </div>
                            <!-- <div class="text-xs font-medium text-neutral-800 p-3 bg-neutral-100 rounded-md">April Present - <span>1</span> </div> -->
                            <div class="text-xs font-medium text-neutral-800 p-3 bg-neutral-100 rounded-md">Total Days Absent - <span>{{totalAbsent}}</span> </div>
                            <!-- <div class="text-xs font-medium text-neutral-800 p-3 bg-neutral-100 rounded-md">April Absent - <span>0</span> </div> -->
                        </div>
                        <div>
                            <button class="w-full text-left px-5 py-3 bg-slate-200 text-black font-medium hover:bg-slate-300 transition flex justify-between items-center rounded-lg" @click="toggleAccordion(1)">
                                Attendance Details
                                <svg :class="{ 'rotate-180': activeIndex === 1 }" class="w-5 h-5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </button>
                            <div v-show="activeIndex === 1" class="pt-2">
                                <div>
                                    <div class="grid grid-cols-6 bg-slate-200 divide-x-[1px] divide-white rounded-md">
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Date</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">In Time</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Out Time</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Hours Worked</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Status</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal justify-center">Remarks</div>
                                    </div>
                                    <div v-if="attendanceList.length > 0">
                                        <div class="grid grid-cols-6 bg-white divide-x-[1px] divide-white rounded-md shadow mt-1.5" v-for="(item, index) in attendanceList" :key="index">
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{item.date}}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{ formatTime(item.check_in) }}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{ formatTime(item.check_out) }}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal text-green-600">
                                                <!-- <span :class="item.total_hours >= fullDay ? 'text-green-600' : item.total_hours >= halfDay ? 'text-orange-600' : 'text-red-600'">{{item.total_hours}} </span>   -->
                                                <span :class="getTimeColor(item.total_hours, fullDay, halfDay)">
                                                    {{item.total_hours}}
                                                </span>
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                            {{item.attendance_type}}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal justify-center">
                                               {{ item.note == "" ? '-' : item.note }} 
                                            </div>
                                       </div>
                                    </div>
                                    <div v-else class="text-center py-5">
                                        No Attendance Record Found
                                    </div>
                                 
                                </div>
                            </div>
                        </div>

                        <div class="my-8 border-t border-neutral-200"></div>

                        <div class="grid grid-cols-1 gap-3 mb-3">
                            <div class="text-xs font-medium text-neutral-800 p-3 bg-neutral-100 rounded-md">Total Number Of Leave - <span>{{totalLeave}}</span> </div>
                        </div>
                        <div>
                            <button class="w-full text-left px-5 py-3 bg-slate-200 text-black font-medium hover:bg-slate-300 transition flex justify-between items-center rounded-lg" @click="toggleAccordion(2)">
                                Leave Details
                                <svg :class="{ 'rotate-180': activeIndex === 2 }" class="w-5 h-5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </button>
                            <div v-show="activeIndex === 2" class="pt-2">
                                
                                <div class="border-neutral-200">
                                    <div class="grid grid-cols-4 bg-slate-200 divide-x-[1px] divide-white rounded-md">
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Leave Date</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Leave Type</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Leave Duration</div>
                                        <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">Status</div>
                                    </div>

                                    <div v-if="leaveList.length > 0">
                                        <div class="grid grid-cols-4 bg-white divide-x-[1px] divide-white rounded-md shadow mt-1.5" v-for="(item, index) in leaveList" :key="index">
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{item.start_date}} {{ 'to' }} {{item.end_date}}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{item.leave_name}}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                {{item.total_days}}
                                            </div>
                                            <div class="text-xs leading-none px-2 py-3 flex items-center font-normal">
                                                <span :class="item.status == 'Approved' ? 'text-green-600' : item.status == 'Pending' ? 'text-orange-600' : 'text-red-600'">{{item.status}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="text-center py-5">
                                        No Attendance Record Found
                                    </div>
                                                                   
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <RightSideBar />
        </section>
    </AdminLayout>
</template>

<script>
import AdminLayout from '../AdminDashboard/AdminLayout.vue';
import RightSideBar from '../../components/RightSideBar.vue';
import { MonthPickerInput } from 'vue-month-picker';
import axios from "axios";
import { BASE_URL } from "../../config";
import moment from 'moment';

export default {
    name: 'AttendanceAdjustment',
    components: {
        AdminLayout,
        RightSideBar,
        // Datepicker,
        MonthPickerInput
    },
    data() {
        return {
            activeIndex: null,
            filterMonth: new Date(),
            empId: "",
            attendanceList: [],
            leaveList: [],
            totalPresent: 0,
            totalAbsent: 0,
            totalLeave: 0,
            monthName: "",
            fullDay: 0,
            halfDay: 0,
            globalDateFormat: '',
        };              
    },

    methods: {
        toggleAccordion(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },

        logEffectiveTo(value) {
            console.log("Effective From Changed:", value);
            this.filterMonth = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            this.getAttendanceLeaveDetails();
        },

        async getAttendanceLeaveDetails(){
            console.log('month', this.filterMonth);
            const formData = {
                "employee_id": this.empId,
                "month": this.filterMonth,
                "company_id": localStorage.getItem('company_id'),
            };
            
            console.log("FORM DATA: ", formData);
            await axios.post(BASE_URL + '/get-attendance-leave-details', formData)
            .then((response) => {
                this.getMonthName(this.filterMonth);
                this.attendanceList = response.data.attendanceRecord;
                this.leaveList = response.data.leaveDetails;
                this.totalPresent = response.data.present_days;
                this.totalAbsent = response.data.absentDays;
                this.totalLeave = response.data.totalLeaveDays;
                this.fullDay = response.data.full_day_hours;
                this.halfDay = response.data.half_day_hours;
                console.log("AR LIST:: ", response.data);

            })
        },

        formatTimee(isoString) {
            if (!isoString || !isoString.$date) return "N/A"; // Handle empty or null values
            const timestamp = isoString.$date["$numberLong"]; // Extract the timestamp
            const date = new Date(parseInt(timestamp)); // Convert to a Date object
            return date.toLocaleTimeString("en-US", { hour12: false }); // Format as HH:mm:ss
        },

        formatTime(isoString) {
            if (!isoString) return "N/A";

            // If isoString is an object with $date, parse timestamp
            if (isoString.$date && isoString.$date.$numberLong) {
                const timestamp = isoString.$date.$numberLong;
                const date = new Date(parseInt(timestamp));
                return date.toLocaleTimeString("en-US", { hour12: false });
            }

            // Otherwise, assume isoString is a ISO8601 string
            const date = new Date(isoString);
            if (isNaN(date)) return "N/A"; // Invalid date check

            return date.toLocaleTimeString("en-US", { hour12: false });
        },

        getMonthName(filterMonth) {
            let [year, month] = filterMonth.split("-");
            // Create a Date object (use the first day of that month)
            let date = new Date(year, month - 1); // month is 0-based
            // Get the month name
            this.monthName = date.toLocaleString('default', { month: 'long' });
            
        },

        getTimeColor(timeStr, fullDay, halfDay) {
            const [hh, mm, ss] = timeStr.split(":").map(Number);
            const totalHours = hh + mm / 60 + ss / 3600;

            if (totalHours >= fullDay) {
                return 'text-green-600';
            } else if (totalHours >= halfDay) {
                return 'text-orange-600';
            } else {
                return 'text-red-600';
            }
        },

        formatDate(date) {
            if (!date) return '';
            return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
        },

    },
    created() {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');  
        const year = now.getFullYear();
        this.filterMonth = `${year}-${month}`;
        this.getMonthName(this.filterMonth);
        this.empId = this.$route.params.slug;
        this.getAttendanceLeaveDetails();
        this.globalDateFormat = localStorage.getItem("globalDateFormat");
    }
};
</script>
<style>
    .monthPickerCst .month-picker-input {
        width: 100%;
        padding: 7px 18px;
        border: none;
    }
    .month-picker__container{
        z-index: 99;
        background: #FFF;
    }
</style>